import{jsxs as o,jsx as t}from"react/jsx-runtime";import i from"styled-components";import{COLORS as r}from"../../constants/Theme.js";import e from"../../assets/icons/cross.svg.js";import{IconButton as a}from"../icon-button/IconButton.js";import{ShimmerImage as n}from"../shimmer-image/ShimmerImage.js";import{Tooltip as c}from"../tooltips/Tooltip.js";import{TitleRegular as d,BodyCaption as l}from"../TypographyStyle.js";import{CurrencySymbols as s}from"./constants.js";import{ProductHelper as u}from"./helpers/ProductHelper.js";import{ProductPickerTag as p}from"./ProductPickerTag.js";import{SKUIDBadge as m,EllipsedBodyTiny as g}from"./style.js";import{getSkuId as v,shouldShowVariant as f}from"./utility.js";const x=i=>o(y,{children:[t(b,{}),t(D,{children:t(a,{className:"close-button",onClick:i.onClose,Icon:e,width:20,height:20})}),t(h,{productData:i.productData,outOfStockAction:i.outOfStockAction,useDynamicInfoImageSize:i.useDynamicInfoImageSize})]}),h=i=>{var e,a,x,h,y,b,D,P,T,S,O,w,$,z,A,F;const C=void 0===i.productData.variants;let H;if(C)H=`${i.productData.currency&&null!==(e=s[i.productData.currency])&&void 0!==e?e:""}${null!==(y=null!==(x=null===(a=i.productData)||void 0===a?void 0:a.price)&&void 0!==x?x:null===(h=i.productData)||void 0===h?void 0:h.actualPrice)&&void 0!==y?y:""}`;else{const o=null===(b=i.productData)||void 0===b?void 0:b.currency;H=`${o&&null!==(D=s[o])&&void 0!==D?D:""}${null!==(A=null!==(O=null===(S=null===(T=Object.values(null!==(P=i.productData.variants)&&void 0!==P?P:{}))||void 0===T?void 0:T[0])||void 0===S?void 0:S.price)&&void 0!==O?O:null===(z=null===($=Object.values(null!==(w=i.productData.variants)&&void 0!==w?w:{}))||void 0===$?void 0:$[0])||void 0===z?void 0:z.actualPrice)&&void 0!==A?A:""}`}const{isVariantForProductPickerTag:N,dataForProductPickerTag:U,tagText:V,tagType:_}=u.getDataForProductPickerTag(i.productData,C,i.outOfStockAction),B=v(i.productData,C);return o(j,{children:[t(k,{children:t(n,{useDynamicInfoImageSize:i.useDynamicInfoImageSize,imageUrl:i.productData.image,width:200,height:200,borderRadius:4})}),o(I,{children:[B&&t(c,Object.assign({body:B,placement:"top"},{children:t(m,{children:t(g,{children:`SKU ID: ${B}`})})})),t(d,Object.assign({style:{display:"flex"}},{children:i.productData.name})),t(l,Object.assign({color:r.content.secondary},{children:`Product ID: ${i.productData.id}`})),t(l,{className:"overlay-description",dangerouslySetInnerHTML:{__html:null!==(F=i.productData.description)&&void 0!==F?F:""}}),t(l,Object.assign({color:r.content.secondary},{children:C?H:f(i.productData)?null:H})),t(p,{isVariant:N,data:U,tagText:V,tagType:_})]})]})},y=i.div`
	display: flex;
	flex: 1;
	background: rgba(0, 0, 0, 0.5);
	flex-direction: column;
	width: 100%;
	height: 100%;
	position: absolute;
	bottom: 0;
	z-index: 10;

	.overlay-description {
		display: flex;
		flex-direction: column;
		max-height: 300px;
		overflow-y: auto;
		word-break: break-word;
		margin-top: 8px;
	}
`,b=i.div`
	display: flex;
	flex: 1;
	background: rgba(0, 0, 0, 0.5);
`,D=i.div`
	position: relative;

	.close-button {
		position: absolute;
		top: -50px;
		right: 0px;
		margin: 10px;
		background: ${r.surface.standard};
		border-radius: 50%;
	}
`,j=i.div`
	display: flex;
	background: white;
	padding: 24px;
	gap: 24px;
	border-radius: 8px 8px 0px 0px;
`,k=i.div`
	display: flex;
	max-width: min(50%, 200px);
	flex-direction: column;
	justify-content: center;
	align-items: center;
`,I=i.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: 4px;
`;export{h as ProductInfoCard,x as ProductInfoOverlay};
